type MovieRecord = {
  id: number;
  title: string;
  originalTitle: string;
  year: number;
  region: "日本" | "韩国";
  type: "电视剧" | "电影";
  genres: string[];
  rating: number;
  popularity: number;
  views: number;
  episodes?: number;
  director: string;
  cast: string[];
  synopsis: string;
  cover: string;
  backdrop?: string;
  featured?: boolean;
};

export const movies: MovieRecord[] = [
  {
    id: 1,
    title: "东京爱情故事",
    originalTitle: "東京ラブストーリー",
    year: 1991,
    region: "日本",
    type: "电视剧",
    genres: ["爱情", "都市"],
    rating: 9.0,
    popularity: 82,
    views: 1280,
    episodes: 11,
    director: "永山耕三",
    cast: ["铃木保奈美", "织田裕二", "江口洋介"],
    synopsis:
      "莉香与完治在东京相遇，一段关于相遇、犹豫与错过都会爱情，成为一代人心中的经典。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20romance%20drama%20poster%20art%20dense%20Tokyo%20night%20skyline%20with%20glowing%20windows%20two%20lovers%20standing%20on%20a%20bridge%20retro%20nineteen%20nineties%20mood%20cool%20blue%20and%20warm%20amber%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20moody%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-01&orientation=portrait",
  },
  {
    id: 2,
    title: "半泽直树",
    originalTitle: "半沢直樹",
    year: 2013,
    region: "日本",
    type: "电视剧",
    genres: ["职场", "剧情"],
    rating: 9.2,
    popularity: 91,
    views: 1560,
    episodes: 10,
    director: "福泽克雄",
    cast: ["堺雅人", "上户彩", "香川照之"],
    synopsis:
      "银行职员半泽直树在派系林立的金融世界里步步为营，以牙还牙，向不公发起正面反击。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20corporate%20drama%20poster%20art%20dark%20boardroom%20with%20long%20table%20city%20financial%20district%20pouring%20rain%20through%20glass%20wall%20tense%20masculine%20mood%20deep%20navy%20and%20steel%20grey%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20dramatic%20side%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-02&orientation=portrait",
  },
  {
    id: 3,
    title: "深夜食堂",
    originalTitle: "深夜食堂",
    year: 2009,
    region: "日本",
    type: "电视剧",
    genres: ["美食", "治愈"],
    rating: 8.8,
    popularity: 74,
    views: 940,
    episodes: 10,
    director: "松冈锭司",
    cast: ["小林薰", "绫田俊树", "松重丰"],
    synopsis:
      "午夜十二点开门的小食堂里，一道道家常菜牵出食客们平凡却动人的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20healing%20food%20drama%20poster%20art%20tiny%20cozy%20late%20night%20diner%20counter%20warm%20amber%20paper%20lanterns%20steam%20rising%20from%20a%20hot%20bowl%20intimate%20nostalgic%20mood%20warm%20orange%20and%20soft%20brown%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20soft%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-03&orientation=portrait",
  },
  {
    id: 4,
    title: "你的名字。",
    originalTitle: "君の名は。",
    year: 2016,
    region: "日本",
    type: "电影",
    genres: ["爱情", "奇幻", "动画"],
    rating: 9.1,
    popularity: 95,
    views: 2100,
    director: "新海诚",
    cast: ["神木隆之介", "上白石萌音"],
    synopsis:
      "一场彗星划过夜空的奇迹，让素未谋面的少年少女交换了身体，也交换了命运。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20animated%20fantasy%20romance%20poster%20art%20shooting%20star%20comet%20streaking%20over%20a%20twilight%20mountain%20town%20two%20teenagers%20reaching%20toward%20the%20sky%20dreamy%20nostalgic%20mood%20violet%20dusk%20and%20soft%20gold%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20glowing%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-04&orientation=portrait",
  },
  {
    id: 5,
    title: "千与千寻",
    originalTitle: "千と千尋の神隠し",
    year: 2001,
    region: "日本",
    type: "电影",
    genres: ["奇幻", "冒险", "动画"],
    rating: 9.4,
    popularity: 98,
    views: 2600,
    director: "宫崎骏",
    cast: ["柊瑠美", "入野自由"],
    synopsis:
      "少女千寻误入神灵的世界，为拯救父母而在汤屋工作，展开一段关于成长的奇幻冒险。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20animated%20fantasy%20poster%20art%20magical%20old%20bathhouse%20with%20red%20lanterns%20arched%20stone%20bridge%20over%20water%20mysterious%20spirits%20in%20the%20mist%20whimsical%20enchanted%20mood%20deep%20red%20and%20teal%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20warm%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-05&orientation=portrait",
  },
  {
    id: 6,
    title: "悠长假期",
    originalTitle: "ロングバケーション",
    year: 1996,
    region: "日本",
    type: "电视剧",
    genres: ["爱情", "都市"],
    rating: 9.0,
    popularity: 70,
    views: 880,
    episodes: 11,
    director: "永山耕三",
    cast: ["木村拓哉", "山口智子"],
    synopsis:
      "失意的钢琴家与逃婚的模特同住一个屋檐下，在人生的悠长假期里互相治愈。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20romance%20drama%20poster%20art%20bright%20summer%20seaside%20apartment%20with%20open%20balcony%20piano%20near%20sunlit%20window%20gentle%20breeze%20relaxed%20nineties%20mood%20airy%20sky%20blue%20and%20cream%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20warm%20sunny%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-06&orientation=portrait",
  },
  {
    id: 7,
    title: "白色巨塔",
    originalTitle: "白い巨塔",
    year: 2003,
    region: "日本",
    type: "电视剧",
    genres: ["医疗", "剧情"],
    rating: 9.3,
    popularity: 80,
    views: 990,
    episodes: 21,
    director: "西谷弘",
    cast: ["唐泽寿明", "江口洋介"],
    synopsis:
      "两位天才医生在学术与权力的巨塔中走向不同道路，一场关于野心与良知的较量。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20medical%20drama%20poster%20art%20cold%20sterile%20hospital%20corridor%20bright%20surgical%20lights%20long%20perspective%20shadow%20serious%20clinical%20mood%20clinical%20white%20and%20cool%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20harsh%20overhead%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-07&orientation=portrait",
  },
  {
    id: 8,
    title: "情书",
    originalTitle: "Love Letter",
    year: 1995,
    region: "日本",
    type: "电影",
    genres: ["爱情", "剧情"],
    rating: 8.9,
    popularity: 72,
    views: 860,
    director: "岩井俊二",
    cast: ["中山美穗", "丰川悦司"],
    synopsis:
      "一封寄往天国的信，意外牵出一段尘封多年的少年暗恋，温柔又令人心碎。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20winter%20romance%20film%20poster%20art%20endless%20snowy%20Hokkaido%20landscape%20a%20single%20handwritten%20letter%20held%20in%20the%20cold%20quiet%20nostalgic%20mood%20soft%20white%20and%20pale%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20gentle%20diffused%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-08&orientation=portrait",
  },
  {
    id: 9,
    title: "孤独的美食家",
    originalTitle: "孤独のグルメ",
    year: 2012,
    region: "日本",
    type: "电视剧",
    genres: ["美食", "治愈"],
    rating: 8.7,
    popularity: 66,
    views: 720,
    episodes: 12,
    director: "溝口憲司",
    cast: ["松重丰"],
    synopsis:
      "一位独自用餐的中年男子，走街串巷寻找平民美食，认真吃饭的样子格外治愈。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20food%20documentary%20poster%20art%20solitary%20man%20seated%20at%20a%20small%20restaurant%20counter%20delicious%20steaming%20dishes%20arranged%20beside%20him%20warm%20inviting%20mood%20appetizing%20toasted%20amber%20and%20wood%20brown%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20cozy%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-09&orientation=portrait",
  },
  {
    id: 10,
    title: "海街日记",
    originalTitle: "海街diary",
    year: 2015,
    region: "日本",
    type: "电影",
    genres: ["家庭", "剧情"],
    rating: 8.8,
    popularity: 69,
    views: 640,
    director: "是枝裕和",
    cast: ["绫濑遥", "长泽雅美", "夏帆"],
    synopsis:
      "镰仓海边老宅里的四姐妹，在四季流转与梅子成熟之间，慢慢拼凑起家的模样。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20family%20drama%20poster%20art%20traditional%20seaside%20wooden%20house%20in%20Kamakura%20four%20sisters%20under%20a%20blooming%20plum%20tree%20gentle%20breezy%20summer%20mood%20soft%20green%20and%20sea%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20natural%20warm%20sunlight%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-10&orientation=portrait",
  },
  {
    id: 11,
    title: "小森林",
    originalTitle: "リトル・フォレスト",
    year: 2014,
    region: "日本",
    type: "电影",
    genres: ["治愈", "剧情"],
    rating: 8.6,
    popularity: 58,
    views: 520,
    director: "森淳一",
    cast: ["桥本爱"],
    synopsis:
      "女孩回到山间小村独自生活，用四季的食材与亲手做的饭菜，与过去的自己和解。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20pastoral%20healing%20film%20poster%20art%20misty%20rural%20mountain%20village%20lush%20green%20rice%20fields%20simple%20homemade%20food%20on%20a%20wooden%20table%20calm%20slow%20seasons%20mood%20earthy%20green%20and%20cream%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20soft%20morning%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-11&orientation=portrait",
  },
  {
    id: 12,
    title: "花束般的恋爱",
    originalTitle: "花束みたいな恋をした",
    year: 2021,
    region: "日本",
    type: "电影",
    genres: ["爱情", "剧情"],
    rating: 8.8,
    popularity: 84,
    views: 1180,
    director: "土井裕泰",
    cast: ["菅田将晖", "有村架纯"],
    synopsis:
      "因错过末班车而相识的两个人，从无话不谈到渐行渐远，爱情像花束一样绽放又凋零。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20bittersweet%20romance%20poster%20art%20young%20couple%20sitting%20across%20a%20small%20Tokyo%20cafe%20table%20fresh%20flowers%20in%20a%20jar%20between%20them%20quiet%20melancholic%20mood%20muted%20rose%20and%20soft%20beige%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20gentle%20window%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-12&orientation=portrait",
  },
  {
    id: 13,
    title: "请回答1988",
    originalTitle: "응답하라 1988",
    year: 2015,
    region: "韩国",
    type: "电视剧",
    genres: ["家庭", "青春", "治愈"],
    rating: 9.7,
    popularity: 99,
    views: 3200,
    episodes: 20,
    director: "申元浩",
    cast: ["李惠利", "朴宝剑", "柳俊烈"],
    synopsis:
      "双门洞五户人家的邻里日常，藏着一代人的青春、亲情与爱情，温暖得让人想回家。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20nostalgic%20family%20drama%20poster%20art%20nineteen%20eighties%20Seoul%20narrow%20neighborhood%20alley%20at%20warm%20dusk%20windows%20glowing%20children%20playing%20together%20cozy%20bittersweet%20mood%20warm%20amber%20and%20soft%20brown%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20golden%20hour%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-13&orientation=portrait",
    featured: true,
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20nostalgic%20backdrop%20warm%20dusk%20over%20a%20nineteen%20eighties%20Seoul%20neighborhood%20alley%20glowing%20windows%20and%20paper%20lanterns%20soft%20golden%20haze%20empty%20upper%20space%20for%20headline%20text%20stylized%20artistic%20illustration%20warm%20amber%20and%20brown%20tones%20subtle%20film%20grain%20soft%20bokeh%20high%20detail%20no%20text&width=1600&height=900&seq=jkhero-13&orientation=landscape",
  },
  {
    id: 14,
    title: "信号",
    originalTitle: "시그널",
    year: 2016,
    region: "韩国",
    type: "电视剧",
    genres: ["悬疑", "犯罪", "奇幻"],
    rating: 9.2,
    popularity: 93,
    views: 1980,
    episodes: 16,
    director: "金元锡",
    cast: ["李帝勋", "金惠秀", "赵震雄"],
    synopsis:
      "一台老旧对讲机连接过去与现在，两位刑警跨越时空联手追凶，改变命运的走向。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20crime%20thriller%20poster%20art%20dark%20rainy%20city%20street%20at%20night%20vintage%20walkie%20talkie%20glowing%20on%20wet%20asphalt%20neon%20reflections%20tense%20mysterious%20mood%20deep%20teal%20and%20cold%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20dramatic%20noir%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-14&orientation=portrait",
  },
  {
    id: 15,
    title: "太阳的后裔",
    originalTitle: "태양의 후예",
    year: 2016,
    region: "韩国",
    type: "电视剧",
    genres: ["爱情", "剧情"],
    rating: 8.5,
    popularity: 88,
    views: 2100,
    episodes: 16,
    director: "李应福",
    cast: ["宋仲基", "宋慧乔"],
    synopsis:
      "特战军官与外科医生在战乱之地相遇，职业与信念的碰撞中萌生出坚定的爱情。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20romance%20drama%20poster%20art%20sunlit%20Mediterranean%20military%20outpost%20at%20golden%20hour%20a%20soldier%20and%20a%20doctor%20standing%20apart%20heroic%20hopeful%20mood%20warm%20sand%20and%20sky%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20bright%20dramatic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-15&orientation=portrait",
  },
  {
    id: 16,
    title: "熔炉",
    originalTitle: "도가니",
    year: 2011,
    region: "韩国",
    type: "电影",
    genres: ["剧情", "犯罪"],
    rating: 9.4,
    popularity: 76,
    views: 1230,
    director: "黄东赫",
    cast: ["孔刘", "郑有美"],
    synopsis:
      "一位美术老师揭开聋哑学校背后的真相，用微弱的力量为沉默的孩子们发声。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20social%20drama%20poster%20art%20somber%20old%20school%20building%20wrapped%20in%20thick%20fog%20single%20distant%20figure%20walking%20away%20heavy%20melancholic%20mood%20desaturated%20grey%20and%20muted%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20cold%20overcast%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-16&orientation=portrait",
  },
  {
    id: 17,
    title: "寄生虫",
    originalTitle: "기생충",
    year: 2019,
    region: "韩国",
    type: "电影",
    genres: ["剧情", "悬疑"],
    rating: 9.0,
    popularity: 97,
    views: 2870,
    director: "奉俊昊",
    cast: ["宋康昊", "李善均", "曹如晶"],
    synopsis:
      "住在半地下室的一家人设法进入豪门工作，两个阶层的碰撞走向难以收拾的结局。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20social%20thriller%20poster%20art%20modern%20minimalist%20concrete%20house%20on%20a%20hill%20under%20heavy%20monsoon%20rain%20dramatic%20staircase%20symbolism%20tense%20cold%20mood%20muted%20green%20and%20grey%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20overcast%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-17&orientation=portrait",
    featured: true,
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20stylized%20backdrop%20modern%20minimalist%20concrete%20house%20on%20a%20rainy%20hill%20with%20long%20dramatic%20staircase%20heavy%20monsoon%20rain%20empty%20upper%20space%20for%20headline%20text%20artistic%20illustration%20muted%20teal%20and%20amber%20accents%20subtle%20film%20grain%20moody%20cinematic%20lighting%20high%20detail%20no%20text&width=1600&height=900&seq=jkhero-17&orientation=landscape",
  },
  {
    id: 18,
    title: "我的大叔",
    originalTitle: "나의 아저씨",
    year: 2018,
    region: "韩国",
    type: "电视剧",
    genres: ["剧情", "治愈"],
    rating: 9.4,
    popularity: 85,
    views: 1420,
    episodes: 16,
    director: "金元锡",
    cast: ["李善均", "李知恩"],
    synopsis:
      "被生活压得喘不过气的中年男人与背负债务的年轻女孩，在彼此身上找到坚持下去的理由。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20quiet%20drama%20poster%20art%20grey%20office%20interior%20and%20empty%20rain%20soaked%20street%20two%20solitary%20figures%20standing%20far%20apart%20restrained%20melancholic%20mood%20cool%20grey%20and%20faded%20blue%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20soft%20overcast%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-18&orientation=portrait",
  },
  {
    id: 19,
    title: "鬼怪",
    originalTitle: "도깨비",
    year: 2016,
    region: "韩国",
    type: "电视剧",
    genres: ["奇幻", "爱情"],
    rating: 9.1,
    popularity: 94,
    views: 2450,
    episodes: 16,
    director: "李应福",
    cast: ["孔刘", "金高银", "李栋旭"],
    synopsis:
      "拥有不死之身的鬼怪与能看见他的少女相遇，一段跨越生死的奇幻浪漫就此展开。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20fantasy%20romance%20poster%20art%20rainy%20old%20cobblestone%20street%20with%20warm%20glowing%20lanterns%20a%20lone%20figure%20holding%20a%20candle%20and%20a%20sword%20mystical%20ethereal%20mood%20deep%20navy%20and%20gold%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20glowing%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-19&orientation=portrait",
    featured: true,
    backdrop:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20mystical%20backdrop%20dark%20rainy%20night%20sea%20with%20a%20glowing%20warm%20golden%20candlelit%20street%20cobblestones%20empty%20upper%20space%20for%20headline%20text%20artistic%20illustration%20deep%20blue%20and%20gold%20accents%20subtle%20film%20grain%20glowing%20cinematic%20lighting%20high%20detail%20no%20text&width=1600&height=900&seq=jkhero-19&orientation=landscape",
  },
  {
    id: 20,
    title: "釜山行",
    originalTitle: "부산행",
    year: 2016,
    region: "韩国",
    type: "电影",
    genres: ["惊悚", "灾难"],
    rating: 8.5,
    popularity: 90,
    views: 2310,
    director: "延尚昊",
    cast: ["孔刘", "马东锡", "郑有美"],
    synopsis:
      "开往釜山的高速列车上爆发丧尸危机，一群陌生人必须在绝境中彼此守护。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20apocalyptic%20thriller%20poster%20art%20dark%20narrow%20train%20carriage%20interior%20blurred%20running%20figures%20flashing%20red%20emergency%20light%20tense%20terrifying%20mood%20desaturated%20steel%20grey%20and%20blood%20red%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20harsh%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-20&orientation=portrait",
  },
  {
    id: 21,
    title: "82年生的金智英",
    originalTitle: "82년생 김지영",
    year: 2019,
    region: "韩国",
    type: "电影",
    genres: ["剧情", "家庭"],
    rating: 8.6,
    popularity: 71,
    views: 880,
    director: "金度英",
    cast: ["郑有美", "孔刘"],
    synopsis:
      "普通的职场女性金智英，在家庭与社会的期待之间，悄然承受着看不见的重压。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20domestic%20drama%20poster%20art%20quiet%20suburban%20home%20kitchen%20with%20soft%20afternoon%20light%20a%20young%20mother%20seen%20from%20behind%20restrained%20emotional%20mood%20soft%20cream%20and%20dusty%20rose%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20gentle%20natural%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-21&orientation=portrait",
  },
  {
    id: 22,
    title: "机智的医生生活",
    originalTitle: "슬기로운 의사생활",
    year: 2020,
    region: "韩国",
    type: "电视剧",
    genres: ["医疗", "治愈", "友情"],
    rating: 9.3,
    popularity: 89,
    views: 1670,
    episodes: 12,
    director: "申元浩",
    cast: ["曹政奭", "柳演锡", "郑敬淏"],
    synopsis:
      "五位从医学院走来的老友，在医院里并肩救人，也在乐队排练室里唱响生活的温柔。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20warm%20medical%20friendship%20poster%20art%20bright%20hospital%20band%20practice%20room%20five%20friends%20with%20instruments%20friendly%20cheerful%20mood%20fresh%20teal%20and%20warm%20cream%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20soft%20even%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-22&orientation=portrait",
  },
  {
    id: 23,
    title: "天空之城",
    originalTitle: "SKY 캐슬",
    year: 2018,
    region: "韩国",
    type: "电视剧",
    genres: ["剧情", "家庭", "悬疑"],
    rating: 8.8,
    popularity: 79,
    views: 1120,
    episodes: 20,
    director: "赵贤卓",
    cast: ["廉晶雅", "李泰兰"],
    synopsis:
      "上流社区里，母亲们为子女教育不择手段，光鲜外表下暗流涌动的欲望与秘密。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20family%20thriller%20poster%20art%20luxury%20high%20rise%20apartment%20towers%20at%20cold%20dusk%20lit%20windows%20in%20a%20grid%20tense%20privileged%20mood%20deep%20navy%20and%20champagne%20gold%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20cool%20dramatic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-23&orientation=portrait",
  },
  {
    id: 24,
    title: "阳光先生",
    originalTitle: "미스터 션샤인",
    year: 2018,
    region: "韩国",
    type: "电视剧",
    genres: ["历史", "爱情"],
    rating: 9.0,
    popularity: 78,
    views: 1050,
    episodes: 24,
    director: "李应福",
    cast: ["李炳宪", "金泰梨"],
    synopsis:
      "动荡年代里，流亡归来的少年与贵族小姐在时代洪流中相知相守，浪漫又壮阔。",
    cover:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20historical%20romance%20poster%20art%20early%20nineteen%20hundreds%20Seoul%20street%20with%20row%20of%20paper%20lanterns%20elegant%20costumed%20figures%20walking%20bittersweet%20grand%20mood%20muted%20deep%20blue%20and%20antique%20gold%20color%20grading%20minimal%20clean%20gradient%20background%20subtle%20film%20grain%20soft%20cinematic%20lighting%20professional%20entertainment%20key%20art%20high%20detail%20no%20text&width=480&height=720&seq=jkposter-24&orientation=portrait",
  },
];